module.exports = __webpack_public_path__ + "static/media/act-6.a6a74423.pdf";